export enum QUESTIONS_CATEGORY {
  TRIP = 'trip',
  PROFILE = 'profile',
  COMPANION = 'companion',
}
